import advisorIconKredita from "@krea/customer-features/images/company/Olli_Lappi.jpg";
import advisorIcon from "@krea/customer-features/images/company/Ella_Almstedt.jpg";
import { settings } from "@krea/customer-features/settings";
import { useGetCachedCurrentLoanApplication } from "@krea/customer-features/store/current-loan-application/hooks";
import { twMerge } from "@krea/shared/design-system/tailwind-utils";
import { CountryCode } from "@krea/shared/types/common";

interface IAdvisorImageProps {
  className?: string;
}

export const AdvisorImage = ({ className }: IAdvisorImageProps) => {
  const { data } = useGetCachedCurrentLoanApplication();
  const { assignedToAdminUser: adminUser } = data ?? {};
  const { profileImage } = adminUser ?? {};
  const countryCode = settings.countryCode;
  let imageSrc = advisorIcon;

  if (profileImage?.lowResolutionUrl) {
    imageSrc = profileImage.lowResolutionUrl;
  } else if (countryCode === CountryCode.FI) {
    imageSrc = advisorIconKredita;
  }

  return (
    <div
      className={twMerge(
        "tw-h-auto tw-w-[50px] tw-shrink-0 tw-align-middle",
        className,
      )}
    >
      <img alt="Advisor" className="tw-h-full tw-w-full" src={imageSrc} />
    </div>
  );
};
